import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[formControl][ktDateMask]',
})
export class DateMaskDirective {
  constructor(private el: ElementRef, private renderer: Renderer2, public ngControl: NgControl) {}

  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    const formattedValue = this.formatDate(value);
    this.renderer.setProperty(this.el.nativeElement, 'value', formattedValue);
  }

  private formatDate(value: string): string {
    // Remove non-digit characters
    const cleanedValue = value.replace(/\D/g, '');

    // Format as MMDDYYYY
    const month = cleanedValue.substring(0, 2);
    const day = cleanedValue.substring(2, 4);
    const year = cleanedValue.substring(4, 8);

    return `${month}${day && day !== '' ? '/' + day : ''}${year && year !== '' ? '/' + year : ''}`;
  }
}
